// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paineis-container {
  padding: 32px;
}

.paineis-fullscreen {
  padding: 0 !important;
}

.paineis-subtitle {
  color: var(--ui-muted);
  margin-bottom: 32px;
  font-size: 14px;
}

/* Grid de cards */
.paineis-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 280px));
  gap: 24px;
}

/* Card individual */
.painel-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  padding-top: 20px;
  background: var(--ui-surface);
  border: 1.5px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-sm);
  cursor: pointer;
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  position: relative;
  overflow: hidden;
}

.painel-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--ui-shadow-md);
}

/* Barra colorida no topo — div separada para evitar problema com ::before */
.painel-card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  border-radius: var(--ui-radius-lg) var(--ui-radius-lg) 0 0;
}

/* Bolha do ícone */
.painel-card-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: var(--ui-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Textos */
.painel-card-titulo {
  font-size: 15px;
  font-weight: 700;
  color: var(--ui-text);
  letter-spacing: 0.4px;
  line-height: 1.3;
}

.painel-card-label {
  font-size: 12px;
  font-weight: 600;
  opacity: 0;
  transform: translateY(4px);
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.painel-card:hover .painel-card-label {
  opacity: 1;
  transform: translateY(0);
}

/* Viewer do iframe */
.painel-viewer {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
}

.painel-viewer-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  background: var(--ui-surface);
  border-bottom: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-sm);
}

.painel-viewer-titulo {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.painel-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  background: var(--azul);
  color: var(--branco);
  border: none;
  border-radius: var(--ui-radius-sm);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
}

.painel-back-btn:hover {
  opacity: 0.85;
}

.painel-iframe {
  flex: 1 1;
  width: 100%;
  border: none;
  background: var(--fundo);
}

@media (max-width: 600px) {
  .paineis-container {
    padding: 20px 16px;
  }

  .paineis-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Paineis/paineis.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,uDAAuD;EACvD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0DAA0D;AAC5D;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".paineis-container {\n  padding: 32px;\n}\n\n.paineis-fullscreen {\n  padding: 0 !important;\n}\n\n.paineis-subtitle {\n  color: var(--ui-muted);\n  margin-bottom: 32px;\n  font-size: 14px;\n}\n\n/* Grid de cards */\n.paineis-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 280px));\n  gap: 24px;\n}\n\n/* Card individual */\n.painel-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 24px;\n  padding-top: 20px;\n  background: var(--ui-surface);\n  border: 1.5px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-sm);\n  cursor: pointer;\n  text-align: left;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.painel-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--ui-shadow-md);\n}\n\n/* Barra colorida no topo — div separada para evitar problema com ::before */\n.painel-card-accent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  border-radius: var(--ui-radius-lg) var(--ui-radius-lg) 0 0;\n}\n\n/* Bolha do ícone */\n.painel-card-icon-wrap {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--ui-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Textos */\n.painel-card-titulo {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ui-text);\n  letter-spacing: 0.4px;\n  line-height: 1.3;\n}\n\n.painel-card-label {\n  font-size: 12px;\n  font-weight: 600;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity 0.18s ease, transform 0.18s ease;\n}\n\n.painel-card:hover .painel-card-label {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Viewer do iframe */\n.painel-viewer {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 60px);\n}\n\n.painel-viewer-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 20px;\n  background: var(--ui-surface);\n  border-bottom: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.painel-viewer-titulo {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.painel-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 18px;\n  background: var(--azul);\n  color: var(--branco);\n  border: none;\n  border-radius: var(--ui-radius-sm);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n}\n\n.painel-back-btn:hover {\n  opacity: 0.85;\n}\n\n.painel-iframe {\n  flex: 1;\n  width: 100%;\n  border: none;\n  background: var(--fundo);\n}\n\n@media (max-width: 600px) {\n  .paineis-container {\n    padding: 20px 16px;\n  }\n\n  .paineis-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
